



      
      import Debug from 'debug'
import { lazyInject } from '@/app/container';
import { CommandQueue, CancelToken } from '@/app/shared/command-queue'
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { TrackingService2, TrackingService2Symbol, createCommand, createQuery } from '@/app/tracking/api';
import UiTaskHeaderComponent from '@/app/shared/components/ui/ui-task-header-component.vue';
import InteractionHeaderComponent from './interaction-header-component.vue';
import * as Api from "@/app/interaction/api";
import { UpdateInteractionStateTrackingCommand } from "../tracking/api";
import { InteractionStateService, InteractionStateServiceSymbol,
         InteractionStateMachine, InteractionStateMachineSymbol,
         InteractionStateMachineData } from '../service'

const debug = Debug('interaction-component');

@Component({
  components: {
    UiTaskHeaderComponent,
  }
})
export default class InteractionComponent<TContent, TState> extends Vue {
  
  @Prop({ required: true })
  id: string
  
  @Prop({ required: true })
  type: string

  @Prop({ required: true })
  content: TContent
  
  @Prop({ required: true })
  title: string | null

  @Prop({ required: true })
  instruction: string | null

  private currentComponent?: Api.InteractiveVueComponent<TState, TContent>

  @lazyInject(Api.InteractiveComponentFactorySymbol) 
  private interactionComponentFactory: Api.InteractiveComponentFactory<TState, TContent>;

  @lazyInject(InteractionStateServiceSymbol)
  private interactionService: InteractionStateService

  @lazyInject(InteractionStateMachineSymbol)
  private stateMachine: InteractionStateMachine<TState>;

  mounted() {
    debug('mounted', this.id, this.type);

    this.stateMachine.onResetComponent = (state) => this.handleResetComponent(state)
    this.stateMachine.initialize(this.id, this.type);

    this.stateMachine.start()
  }

  @Watch('stateMachineData.state')
  public handleStateMachineStateChanged(newValue: unknown): void {
    debug('handleStateMachineStateChanged', newValue)
  }

  private handleResetComponent(state: TState | null) {
    debug('handleResetComponent', this.id, this.type, state)

    if (this.currentComponent) {
      this.destroyInteractionComponent();
    }

    this.createInteractionComponent(state);
  }

  private beforeDestroy() {
    this.stateMachine.cancel()
    this.destroyInteractionComponent();
  }

  private createInteractionComponent(state: TState | null) {
    debug('createInteractionComponent', this.id, this.type);

    const component = this.interactionComponentFactory(
      this.type, { 
        result: null, state: state,
        meta: { id: this.id, title: this.title },
        content: this.content
      }
    );

    debug('component', component)
    
    const headerComponent = this.$createElement(InteractionHeaderComponent, {
        props: {
          title: this.title,
          instruction: this.instruction,
          type: this.type
        }
    })

    component.$slots['header'] = [ headerComponent ]

    component.$on('interaction-state-changed', this.handleStateChanged);
    component.$on('interaction-result-changed', this.handleResultChanged);
    component.$mount();

    const container = <HTMLElement>this.$refs['interaction-component-container'];
    container.appendChild(component.$el);
    
    this.currentComponent = component
  }

  private destroyInteractionComponent() {
    debug('destroyInteractionComponent', this.id, this.type);

    if (this.currentComponent) {
      this.currentComponent.$off([
        "interaction-state-changed",
        "interaction-result-changed"
      ]);
      this.currentComponent.$destroy();
      $(this.currentComponent.$el).remove()
      this.currentComponent = undefined
    }
  }

  private handleStateChanged(state: TState) {

    debug('handleStateChanged', state);

    this.stateMachine.updateInteractionState(state)
  }

  private handleResultChanged(result: Api.Result) {

    debug('handleResultChanged', result);

    this.stateMachine.updateInteractionResult(result.progress, result.status)
  }
}
